// eslint-disable-next-line sonarjs/slow-regex
export const stripHtml = (htmlText: string): string => htmlText.replace(/<\/?[^>]+(>|$)/g, '');
